import React from 'react'

export default function Signup() {
    return (
        <div className="login">
            n mnbcvjda
        </div>
    )
}
